import React from "react";
import {
  TotalEarningIcon,
  ReceivedAmountIcon,
  PendingAmountIcon,
} from "../../constant";
import PaymentStatsCard from "../PaymentStatsCard";
import classes from "./PaymentStats.module.css";
import moment from "moment";
import clsx from "clsx";
const PaymentStats = ({ data, period,className}) => {
  const startDate = moment(moment(period?.startDate).format("YYYY-MM-DD"));
  const endDate = moment(moment(period?.endDate).format("YYYY-MM-DD"));
  console.log("StartDate == >>", startDate);
  console.log("endDate == >>", endDate);
  const duration = endDate?.diff(startDate, "days") + 1;
  return (
    <div className={(clsx(classes.wrapper,className))}>
      <PaymentStatsCard
        period={duration}
        number={data?.totalEarnings}
        percentage={data?.totalEarningsGrowth}
        title={"Total Earnings"}
        icon={<TotalEarningIcon />}
      />

      <PaymentStatsCard
        period={duration}
        number={data?.receivedAmount}
        percentage={data?.receivedAmountGrowth}
        title={"Received Amount"}
        icon={<ReceivedAmountIcon />}
      />
      <PaymentStatsCard
        period={duration}
        number={data?.pendingAmount}
        percentage={undefined}
        title={"Pending Amount"}
        icon={<PendingAmountIcon />}
      />
      {/* <UserStatsCard number={data?.activeUsers} title={"Active Users"} icon={<ReceivedAmountIcon />} period={period} />
      
        
          <UserStatsCard number={data?.totalBookings} title={"Total Bookings"} icon={<PendingAmountIcon />} period={period} /> */}
    </div>
  );
};

export default PaymentStats;
